/*
* @描述: 报价单详情
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-01-13 17:21:48
*/
<template>
    <div v-loading="loading" class="quotation_detail_page">
        <div class="quotation_detail_header">
            <div class="quotation_detail_header_left">
                <i class="iconfont icon-baojiadan"></i>
                <span class="quotation_detail_header_title" v-text="projectQuotationDetail.title"></span>
                <span class="quotation_status_name" v-text="projectQuotationDetail.status_name"></span>
            </div>
            <div class="quotation_detail_header_right flex_wrap">
                <div v-if="projectQuotationDetail.status===4"
                     v-auth="'order.edit'"
                     class="detail_handle_icon_wrap"
                     permission_type="customer"
                     route_name="Order"
                     @click="handleClickCreateOrder">
                    <i class="iconfont icon-a-dingdan1"></i>
                    <span>生成订单</span>
                </div>
                <el-dropdown v-if="permission['project.quotation.edit']" placement="bottom-end" trigger="click">
                    <div class="detail_handle_icon_wrap">
                        <i class="iconfont icon-gengduo"></i>
                        <span>更多</span>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                                v-if="projectQuotationDetail.status===4||projectQuotationDetail.status===5||projectQuotationDetail.status===6||projectQuotationDetail.status===7"
                                @click.native="handleClickShareQuotation">分享
                        </el-dropdown-item>
                        <el-dropdown-item @click.native="handleClickQuotationAgain">再次报价</el-dropdown-item>
                        <el-dropdown-item @click.native="handleClickDownloadQuotation">下载</el-dropdown-item>
                        <el-dropdown-item @click.native="handleClickPrintQuotation">打印</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="quotation_detail_content">
            <div class="left_content_wrap">
                <div class="page_little_title">
                    <span class="title">报价单详情</span>
                </div>
                <div class="quotation_detail_wrap">
                    <TemplateComponent ref="templateComponent"
                                       v-if="dataLoaded"
                                       :project_quotation_tmpl_form="project_quotation_tmpl_form"
                                       :fields_list="quotationFieldsList"
                                       :quotation_detail="projectQuotationDetail"
                                       :templateType="'detail'"/>
                </div>
            </div>
            <div class="right_content_wrap">
                <div class="customer_feedback_list_wrap">
                    <div class="page_little_title">
                        <span class="title">客户反馈</span>
                    </div>
                    <ul v-if="quotationFeedbackList.length" class="customer_feedback_list">
                        <li v-for="item in quotationFeedbackList" class="customer_feedback_item">
                            <div class="created_at" v-text="item.created_at"></div>
                            <p class="content_detail" v-text="item.content.details"></p>
                        </li>
                    </ul>
                    <div v-else class="no_data">暂无数据</div>
                </div>
                <div class="quotation_log_list_wrap">
                    <div class="page_little_title">
                        <span class="title">历史动态</span>
                    </div>
                    <ul v-if="quotationLogList.length" class="quotation_log_list">
                        <li v-for="item in quotationLogList"
                            class="quotation_log_item">
                            <div class="flex_js_wrap">
                                <PersonnelCard v-if="item.uid" :userId="item.uid">
                                    <template slot="container">
                                        <div class="user-avatar-btn">
                                            <img :src="item.user_avatar?item.user_avatar:defaultImg" alt=""
                                                 class="user_avatar">
                                            <span class="user_name" v-text="item.user_name"></span>
                                        </div>
                                    </template>
                                </PersonnelCard>
                                <div class="created_at" v-text="item.created_at"></div>
                            </div>
                            <p class="log_detail" v-text="item.content.details"></p>
                        </li>
                    </ul>
                    <div v-else class="no_data">暂无数据</div>
                </div>
            </div>
        </div>
        <OrderSubmitAgain v-if="createOrderDialogVisible"
                          :dialogVisible.sync="createOrderDialogVisible"
                          :project_quotation_id="project_quotation_id"/>
        <quotationShareDialog v-if="shareDialogVisible"
                              :dialogVisible.sync="shareDialogVisible"
                              :quotation_key="projectQuotationKey"
                              :quotation_title="projectQuotationDetail.title"/>
        <quotationDownloadDialog v-if="quotationDownloadDialog"
                                 :dialogVisible.sync="quotationDownloadDialog"
                                 :quotation_id="project_quotation_id"/>
        <quotationPrintDialog v-if="quotationPrintDialog"
                              :dialogVisible.sync="quotationPrintDialog"
                              :quotation_id="project_quotation_id"/>
    </div>
</template>
<script>
import TemplateComponent from "@/views/pc/Business/component/template_component_detail";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import quotationShareDialog from "./component/quotation_share_dialog";
import quotationDownloadDialog from "./component/quotation_download_dialog";
import quotationPrintDialog from "./component/quotation_print_dialog";
import OrderSubmitAgain from "@/views/pc/Order/component/order_submit_again";
import {
    projectQuotationDetail,
    projectQuotationFeedbackList,
    projectQuotationLogList,
    projectQuotationShare
} from "@/api";

export default {
    name: "QuotationDetails",
    data() {
        return {
            project_quotation_tmpl_form: '',
            project_quotation_id: Number(this.$route.query.project_quotation_id),
            loading: false,
            projectQuotationDetail: {},
            quotationFieldsList: [],
            quotationFeedbackList: [],
            quotationLogList: [],
            defaultImg: require('@/assets/images/default.jpg'),
            dataLoaded: false,
            shareDialogVisible: false,
            quotationDownloadDialog: false,
            quotationPrintDialog: false,
            projectQuotationKey: '',
            permission: {},
            createOrderDialogVisible: false,
        }
    },
    components: {
        TemplateComponent,
        PersonnelCard,
        quotationShareDialog,
        quotationDownloadDialog,
        quotationPrintDialog,
        OrderSubmitAgain,
    },
    created() {
    },
    computed: {},
    mounted() {
        this.getQuotationDetail()
    },
    methods: {
        //获取报价单详情
        getQuotationDetail() {
            this.loading = true
            projectQuotationDetail({
                project_quotation_id: this.project_quotation_id
            }).then(res => {
                if (res.code === 200) {
                    this.project_quotation_tmpl_form = res.data.project_quotation_tmpl_form
                    this.projectQuotationDetail = res.data
                    this.permission = res.data.permission
                    this.quotationFieldsList = res.data.custom_fields
                    this.dataLoaded = true
                    projectQuotationFeedbackList({
                        project_quotation_id: this.project_quotation_id
                    }).then(res => {
                        if (res.code === 200) {
                            this.quotationFeedbackList = res.data.data
                        } else {
                            this.$message.error(res.message)
                        }
                        this.loading = false
                    })
                    projectQuotationLogList({
                        project_quotation_id: this.project_quotation_id
                    }).then(res => {
                        if (res.code === 200) {
                            this.quotationLogList = res.data.data
                        } else {
                            this.$message.error(res.message)
                        }
                        this.loading = false
                    })
                } else {
                    this.$message.error(res.message)
                    this.loading = false
                }
            })
        },

        //再次报价
        handleClickQuotationAgain() {
            this.$router.push({
                name: 'QuotationAdd',
                query: {
                    project_quotation_tmpl_form: this.projectQuotationDetail.project_quotation_tmpl_form,
                    project_quotation_id: this.projectQuotationDetail.project_quotation_id,
                },
            })
        },

        //生成订单
        handleClickCreateOrder() {
            this.createOrderDialogVisible = true
        },

        //分享报价单
        handleClickShareQuotation() {
            projectQuotationShare({
                project_quotation_id: this.project_quotation_id
            }).then(res => {
                if (res.code === 200) {
                    this.projectQuotationKey = res.data.key
                    this.shareDialogVisible = true
                } else {
                    this.$message.error(res.message)
                }
            })
        },

        //打印报价单
        handleClickPrintQuotation() {
            this.quotationPrintDialog = true
        },

        //下载报价单
        handleClickDownloadQuotation() {
            this.quotationDownloadDialog = true
        },
    },
}
</script>
<style lang="scss" scoped>
.quotation_detail_page {
    width: 100%;
    height: 100%;
    background-color: #EDF0F4;

    .quotation_detail_header {
        padding: 16px 16px 12px;
        background-color: #FFFFFF;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .quotation_detail_header_left {
            display: flex;
            align-items: center;
            gap: 8px;

            .quotation_detail_header_title {
                font-size: 18px;
                font-weight: 700;
                line-height: 28px;
                color: #333333;
            }

            .quotation_status_name {
                display: inline-block;
                padding: 2px 8px;
                border-radius: 4px;
                background: rgba(240, 170, 50, 0.1);
                border: 1px solid #F0AA32;
                color: #F0AA32;
            }
        }
    }

    .quotation_detail_content {
        padding: 4px;
        display: flex;
        gap: 4px;
        overflow: hidden;
        height: calc(100% - 56px);

        .left_content_wrap {
            flex: 1;
            border-radius: 6px;
            background: #FFFFFF;
            padding: 16px;

            .quotation_detail_wrap {
                height: calc(100% - 38px);
                overflow: auto;
            }
        }

        .right_content_wrap {
            width: 404px;
            display: flex;
            flex-direction: column;
            gap: 4px;

            .customer_feedback_list_wrap {
                height: 214px;
                padding: 16px;
                border-radius: 6px;
                background: #FFFFFF;

                .page_little_title {
                    margin-bottom: 12px;
                }

                .customer_feedback_list {
                    height: calc(100% - 34px);
                    overflow: auto;

                    .customer_feedback_item {
                        margin-bottom: 12px;

                        .created_at {
                            line-height: 22px;
                            color: #333333;
                            margin-bottom: 4px;
                        }

                        .content_detail {
                            padding: 8px 12px;
                            border-radius: 6px;
                            background: #EDF0F4;
                            color: #666666;
                            line-height: 22px;
                        }
                    }
                }
            }

            .quotation_log_list_wrap {
                padding: 16px;
                border-radius: 6px;
                background: #FFFFFF;
                flex: 1;
                max-height: calc(100% - 218px);

                .page_little_title {
                    margin-bottom: 12px;
                }

                .quotation_log_list {
                    height: calc(100% - 34px);
                    overflow: auto;

                    .quotation_log_item {
                        margin-bottom: 16px;

                        .user_avatar {
                            width: 22px;
                            height: 22px;
                            border-radius: 50%;
                        }

                        .user_name {
                            line-height: 22px;
                            color: #333333;
                            margin-left: 4px;
                        }

                        .created_at {
                            font-size: 12px;
                            line-height: 22px;
                            color: #666666;
                        }

                        .log_detail {
                            padding: 8px 12px;
                            border-radius: 4px;
                            background-color: #EDF0F4;
                            margin-top: 8px;
                            color: #666666;
                            line-height: 22px;
                        }
                    }
                }
            }

            .no_data {
                text-align: center;
                color: #999999;
            }
        }
    }
}
</style>
